






































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { PreCollection } from '@/resource/pre-collection/pre-collection.model';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import PreCollectionPdfOnly from '@/components/modals/ModalPreCollectionPdfOnly.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import { getUserStatus } from '@/utils/cookie';
import { UserStatus } from '@/resource/user/user.model';
import PurchaseStore, {
  PurchaseStoreInterface,
} from '@/resource/purchase/purchase.store';
import {
  CourseItem,
  UpdatedCourseItem,
} from '@/resource/course-item/course-item.model';
import Icon from '@/main-components/common/Icon.vue';
import ModalCourseContent from '@/components/course/ModalCourseContent.vue';

@Component({
  components: {
    BeatLoader,
    PreCollectionPdfOnly,
    Icon,
    MainButton,
    ModalCourseContent,
  },
})
export default class CoursePurchasedDetail extends Vue {
  @Prop({ required: true })
  currentPreCollection!: PreCollection;

  @Prop({ required: true })
  courseItems: CourseItem[];

  @Prop({ required: true })
  isPurchased!: boolean;

  isDownloadPdfLoading = false;
  isCopyCollectionLoading = false;
  showPdfOnlyModal = false;
  showRegister = false;
  pdfDownloadedCounter: number | null = null;
  purchaseStore: PurchaseStoreInterface = PurchaseStore;
  courseProgress = 0;
  updatedCourseItems: UpdatedCourseItem[];
  openModalCourseContent: any = null;
  closeModalCourseContent: any = null;
  screenWidth = 0;

  get purchaseUuid() {
    return this.purchaseStore.purchase?.uuid;
  }

  get userStatus(): UserStatus {
    return getUserStatus() || UserStatus.Free;
  }

  get isPremiumStatus() {
    return this.userStatus === UserStatus.Premium;
  }

  created() {
    const purchase = this.purchaseStore.purchase;

    if (purchase) {
      this.courseProgress = purchase.progress;
    }

    this.updatedCourseItems = this.courseItems.map((item, index) => {
      return { ...item, active: index === this.courseProgress };
    });

    this.$emit('courseProgress', this.courseProgress);

    window.addEventListener('resize', this.getScreenWidth);
    this.getScreenWidth();

    this.scrollToSelectedItem();
  }

  async scrollToSelectedItem() {
    // Get the index of the previously selected item from your component's data
    const selectedItemId = this.courseProgress;

    // Scroll to the item
    if (selectedItemId !== null) {
      await this.$nextTick();

      const itemList = this.$refs.itemList as HTMLElement;

      const selectedItem = Array.from(itemList.children).find(
        child => child.getAttribute('data-id') === selectedItemId.toString(),
      ) as HTMLElement;

      if (selectedItem) {
        selectedItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  @Watch('screenWidth')
  onScreenWidthChange() {
    if (this.screenWidth > 800) {
      this.closeModal();
    }
  }

  getScreenWidth() {
    this.screenWidth = window.innerWidth;
  }

  async updateActiveLink(courseItemId: number) {
    this.updatedCourseItems.forEach(item => {
      item.active = item.id === courseItemId;
    });

    this.courseProgress = this.updatedCourseItems.findIndex(
      item => item.active === true,
    );

    if (this.purchaseUuid) {
      await this.purchaseStore.updateOnePurchaseByPurchaseUuid({
        uuid: this.purchaseUuid,
        progress: this.courseProgress,
      });
    }

    this.$emit('courseProgress', this.courseProgress);

    if (this.screenWidth > 800) return;
    this.openModal();
  }

  onClickNext() {
    this.courseProgress++;

    this.updatedCourseItems.forEach((item, index) => {
      item.active = index === this.courseProgress;
    });

    this.$emit('courseProgress', this.courseProgress);

    if (this.screenWidth > 800) return;
    this.openModal();
  }

  onClickPrevious() {
    this.courseProgress--;

    this.updatedCourseItems.forEach((item, index) => {
      item.active = index === this.courseProgress;
    });

    this.$emit('courseProgress', this.courseProgress);

    if (this.screenWidth > 800) return;
    this.openModal();
  }

  openModalCourseContentAdd(openModal: any) {
    this.openModalCourseContent = openModal;
  }
  closeModalCourseContentAdd(closeModal: any) {
    this.closeModalCourseContent = closeModal;
  }

  openModal() {
    this.openModalCourseContent && this.openModalCourseContent();
  }

  closeModal() {
    this.closeModalCourseContent && this.closeModalCourseContent();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.getScreenWidth);
  }
}
